import { Component } from '@angular/core';
import { LandingHeaderComponent } from './components/landing-header/landing-header.component';
import { LandingFooterComponent } from './components/landing-footer/landing-footer.component';
import { BannerLandingComponent } from './components/banner-landing/banner-landing.component';
import { ProblemSectionComponent } from './components/problem-section/problem-section.component';
import { ValuePropComponent } from './components/value-prop/value-prop.component';
import { RoiSectionComponent } from './components/roi-section/roi-section.component';
import { ProcessSectionComponent } from './components/process-section/process-section.component';
import { PreviewSectionComponent } from './components/preview-section/preview-section.component';
import { AcademySectionComponent } from './components/academy-section/academy-section.component';
import { TestimonialsSectionComponent } from './components/testimonials-section/testimonials-section.component';
import { FinalCtaComponent } from './components/final-cta/final-cta.component';
import { PricingPopupComponent } from './components/pricing-popup/pricing-popup.component';
import { NoiPopupComponent } from './components/noi-popup/noi-popup.component';
import { DemoPopupComponent } from './components/demo-popup/demo-popup.component';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    LandingHeaderComponent,
    BannerLandingComponent,
    ProblemSectionComponent,
    ValuePropComponent,
    RoiSectionComponent,
    ProcessSectionComponent,
    PreviewSectionComponent,
    AcademySectionComponent,
    TestimonialsSectionComponent,
    FinalCtaComponent,
    LandingFooterComponent,
    PricingPopupComponent ,
    NoiPopupComponent,
    DemoPopupComponent,
  ],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {
  pricingPopupVisible = false;
  roiPopupVisible = false;
  demoPopupVisible = false;
  closePricingPopup() {
    this.pricingPopupVisible = false;
    document.body.style.overflow = '';
  }
  openPricingPopup() {
    this.pricingPopupVisible = true;
    document.body.style.overflow = 'hidden';
  }
  closeROIPopup() {
    this.roiPopupVisible = false;
    document.body.style.overflow = '';
  }
  openROIPopup() {
    this.roiPopupVisible = true;
    document.body.style.overflow = 'hidden';
  }
  openDemoPopup() {
    this.demoPopupVisible = true;
    document.body.style.overflow = 'hidden';
  }
  closeDemoPopup() {
    this.demoPopupVisible = false;
    document.body.style.overflow = '';
  }
}
